<template>
  <div class="comm-container input-card-wp">
    <div class="input-card-bd">
      <slot></slot>
    </div>
    <div class="input-card-ft">
      <div class="input-card-btn" @click="submit">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputCardBox",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    submit() {
      this.$emit("submit");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InputCardBox.vue